/// In meters
export const DISTANCE_SENSOR_RANGE = 20.0;
